export default __webpack_public_path__ + "assets/wizard-shape-e20d68bf1f6a2e201e30bcbb12eb14ed.svg";